import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Lots from '@/views/Lots'
import NotFound from '@/views/NotFound'
import store from './store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/lots',
            name: 'lots',
            component: Lots
        },
        {
            path: '*',
            name: 'notfound',
            component: NotFound
        }
    ]
})

router.beforeEach((to, from, next) => {
    const connected = store.getters['auth/connected']

    if (to.name !== 'login' && !connected) {
        return next({ path: `/?p=${to.path}` })
    }
    if (to.name === 'login' && connected) {
        return next({ name: 'lots' })
    }
    return next()
})

export default router
